module.exports = __webpack_public_path__ + "static/media/mcr.2aa5558b.png";